import { useMemo, useState, memo } from 'react';
import { Ally } from '../../../mechanics/ally/Ally';
import { useAppSelector } from '../../../store/store';
import ImgWithFallback from '../../ui/ImgWithFallback';

interface ICampAlliesListItemProps {
    ally: Ally
    handleClick: () => void
    index: number
    isInfo: boolean
}

const CampAlliesListItem = ({ ally, handleClick, index, isInfo }: ICampAlliesListItemProps) => {
    const activeIndex = useAppSelector(state => state.campReducer.activeAllyIndex)

    const isAllyActive = useAppSelector(state => state.campReducer.isAllyActive)

    const allyIsActive = useMemo(() => {
        return ally.getIsActive() && <p className='camp-allies__list-item-chosen'>Active</p>
    }, [isAllyActive])

    return (
        <li
            className={`camp-allies__list-item  ${activeIndex === index && isInfo ? '_chosen' : ''}`}
            onClick={handleClick}>
            <div className="camp-allies__list-item-img adaptive-img-contain">
                {ally.getIcon().img && <ImgWithFallback src={ally.getIcon().webp} fallbackSrc={ally.getIcon().img} />}
            </div>
            {allyIsActive}
        </li>
    );
};

export default memo(CampAlliesListItem);